<template>
    <li 
        :class="{
            'active-menu': isSubItemsListOpened,
            'inactive-menu': !isSubItemsListOpened,
        }"
        @click.stop="goToPageRoute(itemRoute, itemTitle)"
    >
        {{ itemTitle }}
        &nbsp;
        <font-awesome-icon
            v-show="subItemList.length > 0"
            style="color: white;"
            size="1x" 
            :icon="isSubItemsListOpened ? 'chevron-down' : 'chevron-left'"
        />

        <div 
            v-show="(subItemList.length > 0) && isSubItemsListOpened" 
            class="submenu-item-list-container"
        >
            <ul>
                <li 
                    v-for="subItem in subItemList" 
                    :key="subItem.subItemTitle" 
                    v-show="subItem.isItemVisible === undefined || subItem.isItemVisible === true"
                    @click.stop="goToPageRoute(subItem.subItemRoute, null, subItem.announcmentSubject)"
                >
                    {{ subItem.subItemTitle }}
                </li>
            </ul>
        </div>
    </li>
</template>

<script>
    export default {
        props: {
            itemTitle: String,
            itemRoute: {
                type: String,
                default: null,
            },
            subItemList: {
                type: Array,
                default(){
                    return [];
                },
            },
            isSubItemsListOpened: {
                type: Boolean, 
                default: false,
            },
        },
        methods: {
            goToPageRoute(route, itemTitle, announcementSubjet) {
                if(announcementSubjet) {
                    this.$emit("send-menuItem-announcement", announcementSubjet);
                    return;
                }

                if(itemTitle) {
                    if(this.isSubItemsListOpened) {
                        this.$emit("close-all-sub-menus", null);
                        return;
                    }
                    else {
                        this.$emit("close-all-sub-menus", itemTitle);
                    }
                }

                if(route) {
                    this.$router.push({ path: `/${route}` });
                    this.$emit("close-mobile-menu");
                }
            }
        }
    }
</script>

<style scoped>
.inactive-menu {
    color: #fff;
}

.active-menu {
    color: skyblue;
}

.submenu-item-list-container {
    width: 100%;
    height: auto;
    margin-top: 5px;
}

.submenu-item-list-container ul {
    width: 100%;
    height: auto;
    margin: 0;
}

.submenu-item-list-container li {
    color: silver;
    list-style-type: none;
    text-align: center;
    font-family: Rajdhani;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 7px;
}
</style>